<template>
    <div class="preloader">
        <div class="pulse"></div>
    </div>
</template>

<script>
  export default {
    name: 'Preloader'
  }
</script>

<style lang="scss" scoped>
    .preloader{
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        width: 100%;
        height: 100%;
        background: #ffffff;
        z-index: 9999;
    }
    .pulse{
        width: 70px;
        height: 70px;
        border-radius: 100px;
        background: #c1ddec;
        margin: auto;
        animation: scaleout 1s infinite ease-in-out;
    }
    @keyframes scaleout {
    0% {
        -webkit-transform: scale(0);
    }
    100% {
           -webkit-transform: scale(1);
           opacity: 0;
       }
    }
</style>